
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs/4-saturday-flexible",
      function () {
        return require("private-next-pages/programs/4-saturday-flexible.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs/4-saturday-flexible"])
      });
    }
  